import { render, staticRenderFns } from "./GoodDamageDetailsInput.vue?vue&type=template&id=6bf2b4b7"
import script from "./GoodDamageDetailsInput.vue?vue&type=script&lang=ts"
export * from "./GoodDamageDetailsInput.vue?vue&type=script&lang=ts"
import style0 from "./GoodDamageDetailsInput.vue?vue&type=style&index=0&id=6bf2b4b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports